<ng-container *ngIf="(isMobile$ | async) === false; else mobile">
  <ng-container *ngIf="isBookingRoute; else terms">
    <app-modal>
      <ng-container content>
        <ng-container *ngTemplateOutlet="terms"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-container>

<ng-template #mobile>
  <ng-container *ngTemplateOutlet="terms"></ng-container>
</ng-template>

<ng-template #terms>
  <div
    class="route-cont {{(isMobile$ | async) ? animation : ''}}"
    [class.no-booking]="!isBookingRoute"
    [class.animated]="isMobile$ | async">
    <div class="header" *ngIf="isBookingRoute">
      <span class="title">{{
        "TERMS_AND_CONDITIONS_MODULE.TITLE" | transloco | uppercase
      }}</span>
      <a (click)="goBack()" class="close-button">
        <i aria-hidden="true" class="icon-close"></i>
      </a>
    </div>
    <div class="content-terms-conditions">
      <div class="box-content">
        <ng-container *ngIf="isCO">
          <h4>Condiciones generales</h4>
          <ul class="clear">
            <li>
              1) Travel Moustache S.A.S. (en adelante "Travel Moustache o la
              Agencia") es una agencia de viajes en línea, identificada con
              Registro Nacional de Turismo (RNT) # 79000, con domicilio en la
              ciudad de Bogotá, D.C., Colombia.
            </li>
            <li>
              2) Travel Moustache permite a una gran cantidad de prestadores de
              servicios turísticos (en adelante "Prestador" o "Prestadores")
              ofrecer y comercializar sus productos y/o servicios a los
              Usuarios/Consumidores de la plataforma Rappi, quienes a su vez
              pueden realizar averiguaciones sobre alojamientos, cruceros,
              vuelos, actividades y demás servicios turísticos (en adelante
              "Servicios Turísticos), así como comparar y reservar dichos
              Servicios Turísticos en tiempo real y adquirirlos por separado o
              combinados, armando y gestionando su viaje, de conformidad con sus
              intereses por medio de la plataforma Rappi.
            </li>
            <li>
              3) En el marco de sus actividades Travel Moustache opera
              únicamente como intermediario entre los Usuarios/Consumidores y
              los Prestadores, entendiéndose que Travel Moustache no es el
              Prestador de los Servicios Turísticos. Por lo anterior, el
              Usuario/Consumidor que contrata los Servicios Turísticos a través
              de Travel Moustache, lo hace directamente con el Prestador.
            </li>
            <li>
              4) Se aclara que los presentes términos y condiciones no
              remplazan, modifican o suplen los términos y condiciones que cada
              Prestador establezca para el disfrute de los Servicios Turísticos
              que presta; por esta razón, resulta indispensable que antes de
              adquirir cualquier Servicio Turístico por intermedio de Travel
              Moustache, el Usuario/Consumidor consulte directamente las
              condiciones, especificaciones y particularidades que cada
              Prestador haya establecido para el Servicio Turístico que desea
              adquirir. Lo anterior, en la medida en que Travel Moustache no
              establece, ni participa en la formulación de los términos y
              condiciones que cada Prestador maneja con relación a sus productos
              y servicios.
            </li>
            <li>
              5) De igual manera, al hacer uso del botón "RappiTravel" dentro de
              la plataforma Rappi, el Usuario/Consumidor acepta y garantiza que:
              (i) es mayor de edad, (ii) posee plena capacidad para la
              celebración de contratos, (iii) está adquiriendo los Servicios
              Turísticos para su uso personal o para quien le haya autorizado
              para actuar, (iv) toda la información proporcionada para la
              adquisición de los Servicios Turísticos por medio de Travel
              Moustache es real, precisa, actual y completa, (v) acepta haber
              leído, entendido y estar de acuerdo con los presentes términos y
              condiciones, (vi) en caso de adquirir Servicios Turísticos con
              destino/escala en Cuba, no es ciudadano ni residente
              Norteamericano, ni se encuentra sujeto a la jurisdicción de
              Estados Unidos.
            </li>
            <li>
              6) Para los efectos de los presentes términos y condiciones, por
              Usuario/Consumidor se entenderá aquella persona natural o jurídica
              que adquiere Servicios Turísticos por medio del botón "Rappi
              Travel" dentro de la plataforma Rappi. Por Pasajero se entenderá
              aquella persona natural o jurídica que disfruta de los Servicios
              Turísticos adquiridos, entendiéndose que el Pasajero no
              necesariamente es el Usuario/Consumidor. Se aclara que tanto los
              Usuarios/Consumidores como los Pasajeros deben dar cumplimiento a
              los presentes términos y condiciones.
            </li>
          </ul>

          <h3>I. RESPONSABILIDAD</h3>
          <ul class="clear">
            <li>
              1) Travel Moustache no se responsabiliza por ninguna clase de
              situación de fuerza mayor (accidentes, huelgas, asonadas,
              terremotos, fenómenos climáticos o naturales, condiciones de
              seguridad, factores políticos, negación de permisos de ingreso,
              asuntos de salubridad y cualquier otro), caso fortuito, hecho
              exclusivo de la víctima, o de un tercero que se presenten antes o
              durante la prestación de los Servicios Turísticos que demoren,
              interrumpan o impidan su pleno disfrute, ni tampoco por los
              riesgos que para la salud e integridad representen los destinos
              turísticos elegidos por los Usuarios/Consumidores, pues
              corresponde a su responsabilidad informarse y tomar medidas al
              respecto. Para este efecto, se tendrán en cuenta las deducciones,
              penalidades, condiciones y gastos de administración previamente
              establecidos por los Prestadores, cuando los Servicios Turísticos
              no sean utilizados.
            </li>
            <li>
              2) Travel Moustache no se responsabiliza personalmente ni de forma
              solidaria con el Prestador, por las sumas solicitadas por parte de
              los Usuarios/Consumidores, así como tampoco por los intereses que
              se generen, en caso de que el Prestador no realice el reembolso
              oportunamente. Lo anterior debido a que Travel Moustache es un
              intermediario entre los Usuarios/Consumidores y los Prestadores.
            </li>
            <li>
              3) El solo uso de la plataforma Rappi implica la aceptación de
              todas y cada una de las condiciones generales y particulares
              incluidas en estos términos y condiciones. Su lectura le permitirá
              ejercer en mejor forma sus derechos como consumidor. Le sugerimos
              imprimirlas y conservarlas, junto con el resto de la documentación
              de viaje.
            </li>
            <li>
              4) Las reservaciones y boletas para la participación en cruceros,
              eventos deportivos y culturales, congresos, ferias, exposiciones y
              similares se sujetarán a las condiciones que señalen las empresas
              organizadoras de tales eventos para cada plan. Dichas condiciones
              se informarán al Usuario/Consumidor al momento de la compra. En
              las condiciones específicas de cada plan se indicará la cuantía de
              los anticipos y el plazo para el pago de la suma por parte del
              Usuario/Consumidor. Por lo anterior, Travel Moustache recomienda
              al Usuario/Consumidor revisar los términos y condiciones
              particulares aplicables al Servicio Turístico que desea contratar.
            </li>
            <li>
              5) Travel Moustache se reserva el derecho de hacer cambios en el
              itinerario, fechas de viaje, hoteles de similar o superior
              categoría, transportes, ante circunstancias de fuerza mayor o caso
              fortuito.
            </li>
            <li>
              6) Travel Moustache se limita a informar al Usuario/Consumidor
              sobre la documentación requerida para facilitar su ingreso a los
              destinos nacionales e internacionales. Por lo anterior, es
              obligación del Usuario/Consumidor verificar en la programación de
              su desplazamiento el cumplimiento de dichos requisitos. Travel
              Moustache en ningún caso se responsabiliza si un país niega al
              pasajero el ingreso, ni tampoco se hace cargo por los gastos
              personales que le acarree tal eventualidad.
            </li>
            <li>
              7) Travel Moustache no se responsabiliza en ninguna circunstancia
              por la pérdida o demora de equipaje o elementos personales del
              Usuario/Consumidor. El Usuario/Consumidor será el único
              responsable por la custodia de su equipaje y objetos personales,
              entre los cuales se incluyen los documentos de viaje.
            </li>
          </ul>

          <h3>II. PROCESO DE RESERVA Y COMPRA</h3>
          <ul class="clear">
            <li>
              1) Cuando el Usuario/Consumidor envía una solicitud de compra a
              través del botón "RappiTravel" dentro de la plataforma Rappi (en
              adelante "Solicitud de Compra"), autoriza a Travel Moustache a
              gestionar su reserva y a cursar el/los respectivo/s cargo/s a su
              cuenta o tarjeta. El Usuario/Consumidor debe prestar atención a
              las comunicaciones posteriores, donde se le informará sobre los
              avances y estado de su Solicitud de Compra. La confirmación de la
              compra depende del pago íntegro del precio y/o tarifa de todos los
              Servicios Turísticos, y mientras no se confirme el pago total de
              la reserva, la Solicitud de Compra quedará en suspenso y podría
              ser cancelada por el Prestador. La confirmación definitiva de los
              Servicios Turísticos y precios se producirá con la emisión del
              tiquete electrónico y/o voucher del servicio. La emisión del
              tiquete electrónico y/o voucher del servicio da fe de la
              aceptación de las condiciones del Prestador y la celebración del
              contrato suscrito entre el Prestador y el Pasajero que aparece en
              dicho tiquete electrónico y/o voucher del servicio.
            </li>
            <li>
              2) Si la Solicitud de Compra quedará sujeta a confirmación, los
              valores pagados antes de la confirmación serán recibidos bajo
              concepto de reserva. Si finalmente la Solicitud de Compra fuera
              rechazada por cualquier motivo (por ejemplo, por saldo
              insuficiente en la tarjeta de crédito, por falta de
              disponibilidad, por variación en la tarifa, entre otros), Travel
              Moustache procederá a informarle al Usuario/Consumidor las
              opciones disponibles en caso de que desee insistir en la compra o
              reserva o, a su requerimiento, le devolverá los importes abonados.
            </li>
          </ul>

          <h3>III. MEDIO DE PAGO Y TARIFAS</h3>
          <ul class="clear">
            <li>
              1) Al realizar una reserva de uno o más Servicios Turísticos a
              través del botón "RappiTravel" dentro de la plataforma Rappi, el
              Usuario/Consumidor debe abonar i) el precio o tarifa fijada por el
              Prestador, ii) los impuestos aplicables al Servicio Turístico;
              iii) el cargo de servicio "service fee" de Travel Moustache, en
              caso de que aplique; y iv) la Tarifa Administrativa (conforme se
              define dicho término más adelante).
            </li>
            <li>
              2) Los medios y formas de pago disponibles para cada Servicio
              Turístico son informados al Usuario/Consumidor al momento de
              solicitar la reserva a través del botón "RappiTravel" dentro de la
              plataforma Rappi.
            </li>
            <li>
              3) Para pagos con tarjetas de crédito: a) El cargo de servicio
              "service fee" de Travel Moustache, en caso de que aplique, podría
              aplicarse íntegro en la primera cuota a pesar de que el
              Usuario/Consumidor haya elegido la opción de pago en cuotas para
              el resto del precio o tarifa. b) Los intereses y/o impuestos que
              pudieran generar los pagos en cuotas, se suman al precio o tarifa
              propuesto para el Servicio Turístico, y dicho total se divide por
              la cantidad de cuotas seleccionada para el pago. c) En caso de
              cancelaciones posteriores a la compra, siempre que las condiciones
              particulares del Servicio Turístico lo permitan, Travel Moustache
              no reintegrará ni se hará responsable por los intereses que la
              transacción original haya generado. d) El precio por pagar puede
              depender del tipo de cambio, por lo que se recomienda al
              Usuario/Consumidor tener esto en consideración para viajes
              internacionales.
            </li>
            <li>
              4) Cuando el Usuario/Consumidor adquiere una tarifa promocional,
              salvo indicación expresa en contrario, en este tipo de tarifas no
              se aceptan cambios, cancelaciones o reembolsos del importe de la
              reserva. El tiquete comprado con tarifa promocional debe ser usado
              en las condiciones en que fue comprado por el Usuario/Consumidor.
              Solo aplicarán excepciones en los casos en que el Prestador acepte
              de manera expresa en sus términos y condiciones, el pago de alguna
              penalidad, por el cambio de las condiciones del Servicio Turístico
              adquirido con una tarifa promocional. El Usuario/Consumidor será
              el responsable de validar los términos y condiciones del Prestador
              correspondiente.
            </li>
          </ul>

          <h3>IV. REVERSIONES DE PAGO</h3>
          <p>
            El Decreto 587 de 2016 del Ministerio de Comercio, Industria y
            Turismo Colombiano le otorga al Usuario/Consumidor la facultad de
            solicitar la reversión de su pago, cuando la adquisición de
            productos turísticos se realice a través del Sitio web. Lo anterior,
            siempre que el pago se haya realizado con una tarjeta de crédito,
            débito o cualquier otro instrumento de pago, electrónico. Se aclara
            que, si la compra corresponde a un tiquete aéreo, el
            Usuario/Consumidor no podrá acogerse a esta figura por expresa
            disposición de la regulación mencionada. En estos casos, el
            Usuario/Consumidor podrá solicitar reversión de pagos por cualquiera
            de las siguientes causales.
          </p>
          <ul>
            <li>Cuando fue objeto de fraude.</li>
            <li>
              Cuando el cargo generado sobre el medio de pago corresponde a una
              operación no solicitada.
            </li>
            <li>Cuando el producto y/o servicio adquirido no fue recibido.</li>
            <li>
              Cuando el producto y/o servicio recibido no corresponde a lo
              solicitado (no cumple con las características informadas o
              atribuidas a éste).
            </li>
            <li>Cuando el producto y/o servicio es defectuoso.</li>
          </ul>
          <p>
            El Usuario/Consumidor podrá solicitar la reversión parcial del pago
            de aquellos productos respecto de los cuales se presente alguno de
            los eventos mencionados anteriormente, expresando claramente cuál es
            el valor por el cual se solicita la reversión, el cual deberá
            corresponder al valor del producto o productos respecto de los
            cuales se presenta la causal.
          </p>
          <p>
            Para que proceda la reversión del pago, dentro los cinco (5) días
            hábiles siguientes a la fecha en que el Usuario/Consumidor tuvo
            noticia de la operación fraudulenta o no solicitada, o que recibió
            la confirmación de una compra no solicitada, deberá presentar queja
            ingresando todos los datos a través del botón denominado "Soporte
            Travel" y notificar de la reclamación al emisor del instrumento de
            pago electrónico utilizado para realizar la compra, el cual, en
            conjunto con los demás participantes del proceso de pago, procederá
            a reversar la transacción al Usuario/Consumidor. Se aclara que la
            reversión se verá reflejada en la cuenta del Usuario/Consumidor en
            el término determinado por el emisor del instrumento de pago. Travel
            Moustache no tiene injerencia sobre dicho término.
          </p>
          <p>
            Travel Moustache advierte al Usuario/Consumidor que en virtud de lo
            dispuesto por el artículo 2.2.2.51.10 del Decreto 587 de 2016, si
            como consecuencia de su solicitud de reversión, el
            Usuario/Consumidor recibiera montos que exceden lo originalmente
            pagado, el Usuario/Consumidor será responsable de la devolución de
            los mismos. Es importante aclarar que de acuerdo con lo establecido
            en el artículo 2.2.2.51.12. del Decreto 587 de 2016, si se demuestra
            que el Usuario/Consumidor no se encontraba incurso en ninguna de las
            causales de reversión establecidas en la reclamación, Travel
            Moustache y/o el emisor de su instrumento de pagos podrán cargar
            definitivamente la transacción reclamada a su tarjeta o medio de
            pago.
          </p>
          <p>
            Como lo establece la regulación, Travel Moustache deja constancia
            que de demostrarse la mala fe del Usuario/Consumidor en el proceso
            de reversión será sancionado por la Superintendencia de Industria y
            Comercio, en los términos artículo 2.2.2.51.13, del Decreto 587 de
            2016 hasta con cincuenta (50) salarios mínimos mensuales legales
            vigentes (SMMLV).
          </p>

          <h3>V. DERECHO DE RETRACTO</h3>
          <p>
            Conforme a lo establecido en el artículo 47 de la Ley 1480 de 2011
            (Estatuto del Consumidor), para hacer efectivo el derecho de
            retracto, el Usuario/Consumidor deberá presentar la solicitud de
            retracto dentro de los cinco (5) días hábiles siguientes a la fecha
            en que realizó la compra. Lo anterior, siempre y cuando no haya
            comenzado a prestarse el Servicio Turístico con anterioridad a dicho
            término. Para ejercer el derecho de retracto el Usuario/Consumidor
            deberá informar a Travel Moustache por escrito. Se aclara que el
            Usuario/Consumidor podrá realizar la solicitud de retracto a través
            de los canales de comunicación dispuestos al interior de la
            Plataforma Rappi, a través del botón soporte al interior de "Rappi
            Travel", enviando un correo electrónico a
            <a href="mailto:servicioalclienteco@rappitravel.com">
              servicioalclienteco&#64;rappitravel.com
            </a>, o llamando a la línea telefónica (601)5800699. Travel Moustache
            realizará el seguimiento de la solicitud ante el Prestador y en caso
            de haber sido abonado, será el Prestador, quien directamente deberá
            proceder con la devolución del dinero en la forma como lo tenga
            previsto en sus términos y condiciones y/o política corporativa.
          </p>

          <h3>VI. CANCELACIONES</h3>
          <ul class="clear">
            <li>
              1) Si el Usuario/Consumidor solicita un cambio o cancelación fuera
              de los plazos y procedimientos establecidos por el Prestador o por
              la ley, y la regulación específica de la tarifa seleccionada así
              lo permitiera, Travel Moustache realizará las gestiones de
              presentación y seguimiento de la solicitud, pero la decisión final
              será del Prestador. Se aclara que la forma de proceder y las
              condiciones especiales que rigen para casos de cambios o
              cancelaciones en una reserva confirmada por el Usuario/Consumidor
              son determinadas por los Prestadores, quienes podrán establecer
              multas o penalidades aplicables para los cambios solicitados.
              Igualmente, se aclara que cada Prestador define sus penalidades
              sin intervención de Travel Moustache.
            </li>
            <li>
              2) En el caso de devoluciones aprobadas por el Prestador, se podrá
              generar una reversión a la misma tarjeta con la cual se hizo la
              reserva, previa autorización del titular de la tarjeta. Si el pago
              fue realizado en efectivo y/o transferencia bancaria, Travel
              Moustache requerirá los datos bancarios para realizar el reembolso
              mediante transferencia bancaria. Los plazos de reembolso y/o de la
              reversión del cargo dependerán de cada Prestador.
            </li>
            <li>
              3) El cargo de gestión y/o Tarifa Administrativa cobrada por
              Travel Moustache es de carácter no reembolsable. En caso de
              cancelación de reservas confirmadas por cualquier motivo, este
              cargo de gestión no será reintegrado al Usuario/Consumidor ya que
              corresponde a un servicio efectivamente prestado por Travel
              Moustache. Así mismo, en el caso supuesto que el
              Usuario/Consumidor solicite el cambio o la cancelación de un
              Servicio Turístico, Travel Moustache podrá cobrar un cargo de
              gestión adicional.
            </li>
          </ul>

          <h3>VII. DATOS PERSONALES</h3>
          <ul class="clear">
            <li>
              1) Travel Moustache y Rappi INC, sus subsidiarias y/o filiales
              tratarán los datos de los Usuarios/Consumidores de conformidad con
              la POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES
              (<a target="_blank"
                  href="https://legal.rappi.com/colombia/politica-de-proteccion-y-tratamiento-de-datos-personales-rappi-s-a-s/" rel="noopener">
                  https://legal.rappi.com/colombia/politica-de-proteccion-y-tratamiento-de-datos-personales-rappi-s-a-s/
                </a>
              ),
              la Ley Estatutaria 1581 de 2012, el Decreto 1377 de 2013, el
              Decreto 886 de 2014 y las normas que las modifiquen o adicionen.
            </li>
            <li>
              2) Al ingresar los datos personales en la plataforma Rappi, el
              Usuario/Consumidor declara que dichos datos son exactos, precisos
              y verdaderos, y asume el compromiso de actualizar dichos Datos
              Personales conforme resulte necesario. Travel Moustache no se
              responsabiliza por la certeza de los Datos Personales provistos
              por el Usuario/Consumidor, cuyos datos deberán coincidir en forma
              exacta con la documentación de viaje.
            </li>
            <li>
              3) El Usuario/Consumidor debe ingresar los datos fiscales exactos
              en el campo denominado "Datos de Facturación" en el botón "Rappi
              Travel", en aras de que Travel Moustache pueda emitir la
              correspondiente factura. En virtud de lo anterior, es
              responsabilidad del Usuario/Consumidor asegurarse de que los datos
              ingresados sean exactos, precisos y verdaderos. Travel Moustache
              no será responsable por la emisión de la factura con información
              errada proporcionada por el Usuario/Consumidor. En caso de
              registrarse errores en los datos de la factura, el
              Usuario/Consumidor podrá solicitar a través del área de soporte de
              Rappi Travel, la corrección de la factura dentro de los tres (3)
              días hábiles siguientes a la recepción de la misma.
            </li>
          </ul>

          <h3>VIII. NO PRESENTACIÓN</h3>
          <p>
            Si el Usuario/Consumidor o el Pasajero no se presentan a utilizar su
            reserva en la fecha y horarios indicados o llegan de forma tardía,
            éstos no tendrán derecho a exigir la devolución total o parcial del
            importe abonado.
          </p>

          <h3>
            IX. PREVENCIÓN RESPECTO A EXPLOTACIÓN, ABUSO O TURISMO SEXUAL CON
            MENORES DE EDAD
          </h3>
          <p>
            En virtud del artículo 17 de la Ley 679 de 2001, la Resolución 3840
            del 24 de diciembre de 2009, y el artículo 1 de la Ley 1336 de 2009,
            se establecen disposiciones para prevenir y contrarrestar la
            explotación sexual comercial, la pornografía, el turismo sexual y
            demás formas de abuso con menores de edad. Bajo ese entendido,
            cualquier incumplimiento a dichas disposiciones podría generar
            sanciones penales y administrativas conforme a las leyes aplicables.
            Igualmente, cada Prestador en sus términos y condiciones determinará
            las medidas tendientes a prevenir cualquiera de estas conductas
            tipificadas como delitos en las leyes.
          </p>

          <h3>X. LICENCIAS Y MARCAS REGISTRADAS</h3>
          <ul class="clear">
            <li>
              1) Travel Moustache opera a través de la plataforma Rappi de
              propiedad de RAPPI INC. quien posee las autorizaciones
              correspondientes para el uso de las imágenes, gráficas, iconos,
              caracteres, música, textos, software, videos y otros contenidos de
              la plataforma Rappi (en adelante, "contenido"), así como de las
              codificaciones HTML, CGI, WS y otros códigos y textos en cualquier
              formato (en adelante, "código") utilizados para implementar la
              plataforma Rappi.
            </li>
            <li>
              2) Ningún código o contenido de la plataforma Rappi podrá ser
              modificado, alterado, copiado, distribuido, retransmitido,
              expuesto, utilizado, reproducido y/o publicado bajo ningún
              concepto.
            </li>
            <li>
              3) Cualquier modificación o uso del contenido o código de la
              plataforma Rappi para propósitos diferentes a los permitidos
              expresamente por Rappi S.A.S. o por Travel Moustache S.A.S.,
              constituye una violación de las leyes de derechos de autor
              (Copyright) y otros derechos de propiedad intelectual, así como a
              las normas penales a que dé lugar la situación particular.
            </li>
          </ul>

          <h4>CONSIDERACIONES ESPECÍFICAS DE LOS SERVICIOS TURÍSTICOS</h4>

          <h3>I. VUELOS</h3>
          <p>
            ● Para efectos de esta sección, por Aerolínea se entenderá a la
            compañía encargada de prestar el servicio de transporte aéreo
            adquirido por el Usuario/Consumidor por medio del botón "Rappi
            Travel" dentro de la plataforma Rappi.
          </p>

          <ul class="clear">
            <li>
              1) Respecto de las tarifas promocionales, económicas y turistas: A
              través del botón "Rappi Travel" dentro de la plataforma Rappi,
              siempre se mostrará la disponibilidad de las tarifas más
              económicas encontradas a través del sistema de distribución GDS.
              Por lo anterior, dichas tarifas contienen mayor restricciones en
              las políticas de cambios, cancelaciones y reembolso, entendiéndose
              que en caso de que el Usuario/Consumidor y/o el Pasajero soliciten
              alguno de los procesos anteriormente mencionados, se podrán
              generar sobrecostos, los cuales deberá ser asumidos por éstos. Se
              aclara que Travel Moustache no se encuentra autorizada a modificar
              en ningún caso las regulaciones de los tiquetes aéreos.
            </li>
            <li>
              2) Tarifa Administrativa: Los cargos por emisión, también
              conocidos como Tarifa Administrativa son cobrados por Pasajero. Se
              aclara que, por regulación de la Unidad Especial de la Aeronáutica
              Civil, dicha Tarifa Administrativa no es reembolsable dado que se
              trata de un cobro obligatorio por la expedición de tiquetes
              aéreos.
            </li>
            <li>
              3) Cancelaci&oacute;n gratuita: Los tiquetes a&eacute;reos que sean gestionados a trav&eacute;s de un GDS podr&aacute;n 
              ser cancelados gratuitamente el mismo d&iacute;a de su compra siempre que la solicitud se presente en correcta 
              forma antes de las 11:45 p.m. hora colombiana. En caso de que este tipo de cancelaci&oacute;n proceda se informar&aacute; 
              en el proceso de compra la posibilidad. Esta cancelaci&oacute;n procede siempre que el tiquete no se encuentre en 
              estado de &ldquo;Check-in&rdquo;. Debe aclararse que el t&eacute;rmino para realizar el Check-in depende de las 
              pol&iacute;ticas internas de cada aerol&iacute;nea, el Usuario/Consumidor deber&aacute; consultar dichas pol&iacute;ticas 
              con la aerol&iacute;nea correspondiente. Esta cancelaci&oacute;n debe ser realizada por el Usuario/Consumidor a 
              trav&eacute;s de la secci&oacute;n &ldquo;Mis Viajes&rdquo; seleccionando el viaje adquirido ese d&iacute;a. Una 
              vez el Usuario/Consumidor realice la cancelaci&oacute;n gratuita se reembolsar&aacute; el valor pagado al mismo 
              medio en el cual realiz&oacute; el pago, este reembolso tomar&aacute; entre quince (15) y veinte (20) d&iacute;as 
              h&aacute;biles dependiendo de la entidad bancaria.
            </li>
            <li>
              4) Desistimiento para tiquetes aéreos: El Usuario/Consumidor podrá
              desistir del viaje dando aviso a la Aerolínea o a Travel Moustache
              con un plazo de al menos veinticuatro (24) horas calendario antes
              del inicio de vuelo. Se aclara que este derecho sólo puede ser
              ejercido por el Usuario/consumidor. En este caso, la Aerolínea
              aplicará una retención de acuerdo con la regla tarifaria aplicable
              sin que ésta exceda el diez por ciento (10%) del valor de la
              tarifa base incluyendo el Q de Combustible. El desistimiento no
              aplica para las tarifas promocionales, y el reembolso se hará
              efectivo dentro de los treinta (30) días siguientes a la fecha de
              notificación a la forma original de pago.
            </li>
            <li>
              5) Retrasos, modificaciones y/o cancelaciones de vuelos por las
              aerolíneas: El Usuario/Consumidor acepta y reconoce que las
              aerolíneas están habilitadas a realizar modificaciones en los
              vuelos programados en tanto las comunique a la autoridad, conforme
              a la regulación aplicable. En relación con lo anterior, se aclara
              que Travel Moustache no interviene en las modificaciones que
              podrían sufrir los vuelos, entendiéndose que, en caso de
              presentarse alguna variación en los mismos, Travel Moustache le
              informará al Usuario/Consumidor las alternativas disponibles y
              solo procederá a confirmar las modificaciones con su aceptación.
              Cualquier reclamo, demanda o denuncia por la prestación del
              servicio escogido deberá ser dirigida a la Compañía Aérea.
              Recuerde que son las aerolíneas las que prestan el servicio de
              transporte. Los derechos del Usuario/Consumidor y los
              procedimientos para hacer efectivas las devoluciones de dinero a
              que estos hechos den lugar, se regirán por las disposiciones
              legales pertinentes y en particular, por las contenidas en el
              Reglamento Aeronáutico Colombiano (RAC) y la Ley 1480 de 2011.
              Cuando por razón de la tarifa o por cualquier otro motivo existan
              restricciones para efectuar modificaciones a la reserva aérea,
              endosos o reembolsos; tales limitaciones se informarán en su
              momento al Usuario/Consumidor.
            </li>
            <li>
              6) El trámite del reembolso de un tiquete lo realiza la Aerolínea
              y el tiempo estimado de reintegro depende de ésta, siempre y
              cuando el tiquete aéreo sea reembolsable. En caso de reembolso, se
              aplicarán las normas y penalidades establecidas por cada Aerolínea
              con base en el tipo de tarifa y sus restricciones. Así mismo, en
              el supuesto que el Usuario/Consumidor solicite la cancelación y el
              reembolso del o los tiquetes, Travel Moustache podrá cobrar un
              cargo de gestión adicional, el cual se realizará por tiquete a
              procesar.
            </li>
            <li>
              7) Algunas tarifas económicas no permiten cambios, cancelaciones
              ni devoluciones, en caso en que -de acuerdo con la reglamentación
              dispuesta por la línea aérea- la tarifa seleccionada por el
              Usuario/Consumidor permita cambios, cancelaciones y/o
              devoluciones, la Aerolínea podrá aplicar cobros adicionales tales
              como penalidades y diferencia de tarifa (resultado de la
              diferencia entre la tarifa originalmente comprada y la nueva
              tarifa según disponibilidad al momento de efectuar el cambio). Se
              aclara que los cambios se deben realizar en las mismas clases
              emitidas o bien en clases superiores. En caso de cancelación y
              reembolso, Travel Moustache realizará la gestión y seguimiento de
              la solicitud frente a la Aerolínea y el Usuario/Consumidor.
              Además, tanto en el caso de cambios como de cancelaciones, Travel
              Moustache podrá cobrar un cargo de gestión adicional.
            </li>
            <li>
              8) En el servicio aéreo se considera menor a una persona que a la
              fecha de viaje no haya cumplido los 12 años de edad. Con base en
              lo anterior, se informa a continuación la clasificación de niños
              en el transporte aéreo con base a su edad: - Infantes: Es todo
              aquel niño que no ha cumplido los dos (2) años a la fecha de
              vuelo, y viaja sin ocupar silla. Se aclara que el infante debe
              estar siempre acompañado por un adulto, y debe ser cargado en el
              regazo por el adulto responsable. Al infante le será emitido un
              tiquete, aunque éste no haya pagado tarifa alguna en vuelos
              domésticos. En tal caso que el adulto desee que infante ocupe
              asiento, éste deberá realizar el pago del boleto de transporte
              aéreo y deberá llevar una silla de infante aprobada por las normas
              internacionales como apta para usarse en una aeronave. - Niños:
              Son aquellos niños que ya han cumplido los dos (2) años de edad y
              no han cumplido los doce (12) años a la fecha del vuelo, los niños
              entre estas edades ocupan asiento y pagan la tarifa informada por
              la Aerolínea.
            </li>
            <li>
              9) Se considerará "menor no acompañado" a aquel que viaje sin al
              menos uno de sus padres o tutores legales. Las Aerolíneas pueden
              ofrecer servicios de asistencia y acompañamiento (con costo) que,
              según el caso, podrán ser obligatorios u opcionales para aquellos
              menores que viajen sin acompañante. Sin embargo, Travel Moustache
              no ofrece este tipo de servicios y no podrá asegurar el efectivo
              embarque del menor en el caso de que la exigencia fuera
              obligatoria. Los menores de entre 2 y 5 años, deberán viajar
              obligatoriamente acompañados por sus padres o responsables a
              cargo. Normalmente el servicio de "menor no acompañado" es
              obligatorio para niños de entre 5 y 11 años, y opcional para niños
              de entre 12 y 17 años. El servicio no está disponible para niños
              que requieran certificación médica para viajar, que no puedan
              alimentarse y/o que no sean capaces de cubrir sus necesidades
              básicas de higiene, y no está disponible para itinerarios con
              escalas o cambios de avión. El Usuario/Consumidor y el Pasajero
              son responsables de consultar la política específica de la
              Aerolínea.
            </li>
            <li>
              10) De acuerdo con lo establecido en el artículo 110 del Código de
              Infancia y Adolescencia modificado por el artículo 9 de la Ley
              1878 de 2018, Travel Moustache informa lo siguiente:
              <p>
                "Cuando un niño, una niña o un adolescente que tiene residencia
                en Colombia vaya a salir del país con uno de los padres o con
                una persona distinta a los representantes legales deberá obtener
                previamente el permiso de aquel con quien no viajare o el de
                aquellos, debidamente autenticado ante notario o autoridad
                consular. Dicho permiso deberá contener el lugar de destino, el
                propósito del viaje y la fecha de salida e ingreso de nuevo al
                país."
              </p>
              <p>
                En caso de realizar un viaje al extranjero con menores de edad,
                Travel Moustache le recomienda al Usuario/Consumidor verificar
                si los menores de edad que viajan cuentan con el nuevo
                pasaporte, en este caso el adulto responsable deberá presentar
                ante las Autoridades de Migración en Colombia, fotocopia
                auténtica y legible del registro civil de nacimiento.
                Adicionalmente, en cumplimiento con lo establecido por la Unidad
                Administrativa Especial de la Aeronáutica Civil (UAEAC), Travel
                Moustache le informa al Usuario/Consumidor que en los vuelos
                nacionales la presentación de la copia del original del Registro
                Civil de los menores de 0 a 7 años al momento de viajar por modo
                aéreo es obligatorio, de lo contrario, los menores no podrán
                viajar a destinos nacionales.
              </p>
            </li>
            <li>
              11) Los servicios especiales son aquellos servicios que se brindan
              con base en las necesidades del Usuario/Consumidor o del Pasajero
              (en adelante "Servicios Especiales"). Dentro de la categoría de
              Servicios Especiales se incluye, entre otros, el servicio de silla
              de ruedas, alimentación especial abordo, mascotas en cabina y
              bodega, y menores sin acompañante. Dichos Servicios Especiales
              deben ser solicitados por el Usuario/Consumidor a Travel Moustache
              con mínimo setenta y dos (72) horas calendario de antelación a la
              fecha del vuelo. Se aclara que los Servicios Especiales están
              sujetos a confirmación por parte de las Aerolíneas con base en la
              disponibilidad, y en algunas ocasiones, estos Servicios Especiales
              pueden generar costos adicionales.
            </li>
            <li>
              12) Las Aerolíneas tienen diferentes políticas de franquicia de
              equipaje. Lo usual en los vuelos nacionales es de 8 kg y en los
              internacionales de 23 kg. Sin embargo, esto puede variar según la
              Aerolínea, y la clase en que viaje el Pasajero, entendiéndose que
              algunas tarifas no incluyen franquicia de equipaje. Travel
              Moustache no se responsabiliza por robo, hurto y/o pérdida de
              equipaje y demás efectos personales de los Pasajeros. En caso de
              pérdida o deterioro de equipaje, el Pasajero debe dirigirse a las
              oficinas de atención al cliente de la Aerolínea y realizar el
              correspondiente reclamo. En todo caso el Usuario/Consumidor y el
              Pasajero deberán informarse sobre esto antes de viajar.
            </li>
            <li>
              13) Si el Usuario/Consumidor no se presenta a utilizar su reserva
              en la fecha y horarios indicados (o llega con retraso), el
              Usuario/Consumidor no tendrá derecho a exigir la devolución total
              o parcial del importe abonado (en adelante "No Show"). Igualmente,
              si el Usuario/Consumidor no va a utilizar su reserva en todo o en
              parte o si va a llegar con retraso a utilizar su reserva, deberá
              comunicarlo previamente a Travel Moustache para conocer las
              restricciones aplicables.
            </li>
            <li>
              14) El Usuario/Consumidor deberá abstenerse de generar más de una
              reserva para el mismo destino- pasajero- fecha - hora y Aerolínea.
              Esto se considera una mala práctica de duplicidad que puede
              ocasionar una cancelación de reserva por parte de la Aerolínea.
            </li>
            <li>
              15) Los tiquetes "SOLO IDA": Por disposiciones migratorias de cada
              país, en caso de que el Pasajero tenga un tiquete únicamente de
              ida, y éste no sea residente del país de destino, podrá ser
              requerido por las autoridades migratorias a justificar las razones
              por las que no cuenta con un tiquete de regreso. En ese caso, el
              Usuario/Consumidor deberá consultar al Consulado o Embajada
              correspondiente antes de efectuar la reserva. Las Aerolíneas
              también podrán exigir esta documentación antes de embarcar.
            </li>
            <li>
              16) La responsabilidad en el transporte aéreo se encuentra
              regulada por la Normativa Aeronáutica. En virtud de lo anterior,
              si el Usuario/Consumidor desea realizar un reclamo respecto del
              contrato de transporte aéreo celebrado entre éste y la Aerolínea,
              puede efectuarlo ante la Aeronáutica Civil Colombiana,
              www.aerocivil.gov.co, organismo encargado de regular, vigilar,
              fiscalizar y certificar la actividad aeronáutica comercial en
              Colombia.
            </li>
          </ul>

          <h3>II. HOTELES</h3>
          <ul class="clear">
            <li>
              1) Las tarifas hoteleras exhibidas en el botón "Rappi Travel"
              dentro de la plataforma Rappi estarán sujetas a la acomodación
              seleccionada por el Usuario/Consumidor. Las políticas de
              cancelación, penalidades y restricciones aplicables a la reserva o
              paquete que desea adquirir el Usuario/Consumidor, serán definidas
              por parte del Prestador.
            </li>
            <li>
              2) La información específica del servicio hotelero como nombre,
              ubicación, categorización, horarios de check-in y check-out, y
              servicios incluidos se encuentra suficientemente detallada en la
              plataforma Rappi. Los Prestadores son responsables exclusivos de
              actualizar las tarifas, la disponibilidad y los otros datos que
              aparecen en la plataforma Rappi.
            </li>
            <li>
              3) Recuerde que, si el Usuario/Consumidor no se presenta en el
              alojamiento en la fecha y horario correspondientes, el alojamiento
              podrá cancelar su reserva y considerarla como No Show. En dicho
              caso, el Usuario/Consumidor no tendrá derecho a exigir el
              reembolso total o parcial del importe abonado. Si por alguna
              circunstancia el Usuario/Consumidor va a llegar fuera de los
              horarios indicados, debe comunicarse previamente con el
              alojamiento y/o con Travel Moustache.
            </li>
            <li>
              4) El Usuario/Consumidor podrá solicitar cambios y/o cancelaciones
              siempre que las condiciones y políticas de la tarifa adquirida lo
              permita. Cualquier excepción a dichas condiciones deberá ser
              autorizada por el alojamiento. Travel Moustache no se encuentra
              autorizada a modificar en ningún caso las políticas y/o
              condiciones de la reserva.
            </li>
            <li>
              5) A través de la sección denominada "Hoteles por horas" dentro del botón 
              "Rappi Travel" en la plataforma Rappi, el Usuario/Consumidor puede hacer 
              la reserva de habitaciones en hoteles seleccionados y sus servicios pagando 
              únicamente por el tiempo exacto que permanecerá en la misma a través de la 
              integración con BYHOURS Travel S.L. de conformidad con sus términos y condiciones 
              disponibles en: 
              <a target="_blank"
              href="https://www.byhours.com/terminos-generales-de-uso.html" rel="noopener">
              Acuerdo de Usuario | BYHOURS
            </a>
            </li>
            <li>
              6) Los extranjeros no residentes en Colombia están exentos de
              tasas/impuestos hoteleros en Colombia acreditando el ingreso al
              país en un periodo no mayor a treinta (30) días, contados desde la
              fecha en que se registraron en el alojamiento. En virtud de lo
              anterior, éstos solo tendrán que pagar el seguro hotelero el cual
              es opcional, y en caso de requerirlo, deberán efectuar el pago del
              mismo al alojamiento directamente. Por el contrario, los Pasajeros
              colombianos deben pagar en el alojamiento las tasas y el seguro
              hotelero opcional en caso de contratarlo. Esta validación se
              realizará directamente en el alojamiento.
            </li>
            <li>
              7) Travel Moustache informa que la actividad de los alojamientos
              domiciliados en la República de Colombia se encuentra regulada por
              un conjunto de normas, entre ellas, la Ley 1480 de 2011, la Ley
              300 de 1996 (Ley General del Turismo), y sus decretos
              reglamentarios, además de las disposiciones especiales
              establecidas por el Ministerio de Comercio, Industria y Turismo, y
              demás autoridades regulatorias y de defensa del consumidor
              colombiano. Si el Usuario/Consumidor desea realizar un reclamo
              respecto del servicio brindado por el alojamiento, puede
              efectuarlo directamente ante los organismos previamente expuestos.
              Para esto, puede ingresar a: www.mincit.gov.co/ y/o
              www.sic.gov.co.
            </li>
            <li>
              8) Travel Moustache podrá solicitar una opinión o reseña al
              Usuario/Consumidor una vez este haya utilizado los servicios de
              alojamiento, y está podrá ser publicada, siempre y cuando, no
              incumpla con alguna de las siguientes condiciones: a) Haga mención
              a términos discriminatorios o racistas; b) Utilice lenguaje
              ofensivo, violento o malintencionado; c) Realice amenazas en
              contra de Travel Moustache, su matriz, subsidiarias y/o filiales,
              del alojamiento, su personal o de otro Usuario/Consumidor; d)
              Utilice expresiones obscenas o sexualmente explícitas; y e)
              Exponga información como páginas web, números de teléfono,
              direcciones de correo electrónico datos de tarjeta de crédito o
              información personal privada.
            </li>
          </ul>

          <h3>III. Vuelo + Hotel</h3>
          <ul class="clear">
            <li>
              1) A través de la sección denominada "Vuelo + Hotel " dentro del
              botón "Rappi Travel" en la plataforma Rappi, el Usuario/Consumidor
              puede armar su viaje de manera autónoma y dinámica, sumando cada
              uno de los servicios que el Usuario/Consumidor desee tomar y
              tendrá la posibilidad de adquirir los diversos productos
              turísticos seleccionados en un único proceso de compra. y un único
              pago. Travel Moustache actúa como una agencia de viajes
              intermediaria, que a través de la Plataforma Rappi permite que los
              Prestadores exhiban, ofrezcan y comercialicen sus Servicios
              Turísticos para que los Usuarios/Consumidores elijan dentro de las
              Servicios Turísticos exhibidos por los Prestadores as
              combinaciones de los Servicios Turísticos que se ajusten a sus
              necesidades.
            </li>
            <li>
              2) Travel Moustache no asesora ni promueve que los
              Usuarios/Consumidores adquieran Servicios Turístico de un
              Prestador específico; los Usuarios/Consumidores a través del botón
              Vuelo + Hotel pueden armar su propio Servicio Turístico
              seleccionando dentro de las alternativas de hoteles y vuelos
              disponibles exhibidos, ofrecidos y comercializados por nuestros
              Prestadores. Los Usuarios/Consumidores antes de realizar el pago
              podrán modificar cualquiera de los Servicios Turísticos
              seleccionados por uno que se adapte mejor a sus necesidades.
              Travel Moustache no actúa como organizador ni es quien elige o
              combina los Servicios Turísticos.
            </li>
            <li>
              3) Cada Servicio Turístico seleccionado por los
              Usuarios/Consumidores para armar su paquete de Vuelo + Hotel,
              establece sus propias condiciones de cambio y/o cancelación
              definidas por cada Prestador. Por lo anterior, cualquier
              modificación y/o cancelación de uno de los Servicio Turístico no
              afecta a los otros Servicios Turísticos adquiridos por los
              Usuarios/Consumidores, los cuales se regirán por sus propias
              condiciones, y deberán ser modificados y/o cancelados
              individualmente siempre que las condiciones establecidas por los
              Prestadores lo permitan.
            </li>
            <li>
              4) Es responsabilidad de los Usuarios/Consumidores la verificación
              con relación a la obligatoriedad de presentar una tarjeta de
              asistencia médica de acuerdo Servicio Turístico Vuelo + Hotel
              adquirido. Por lo tanto, el Usuario/Consumidor deberá presentar la
              tarjeta de asistencia médica al ingreso de la ciudad y/o país. Lo
              anterior, porque algunos países exigen como requisito de ingreso
              obligatorio la presentación de una tarjeta de asistencia médica,
              es responsabilidad de los Usuarios/Consumidores validar los
              requisitos y documentación necesaria para el ingreso al país o
              ciudad de destino. Travel Moustache no es responsable si en el
              país de destino no se le permite el ingreso al Usuario/Consumidor
              o Consumidor final por la falta de documentación requerida.
            </li>
          </ul>

          <h3>IV. ACTIVIDADES</h3>
          <ul class="clear">
            <li>
              1) Se entienden por "Actividades" la contratación de excursiones,
              traslados o atracciones, entre otras que ofrezcan los Prestadores.
            </li>
            <li>
              2) Las Actividades pueden sufrir modificaciones en horarios y
              puntos de partida. Es responsabilidad del Usuario/Consumidor
              confirmar con previa anticipación esta información con el
              Prestador. La información de contacto estará disponible en el
              voucher de confirmación. Travel Moustache no será responsable por
              la omisión de este procedimiento por parte del Usuario/Consumidor.
            </li>
            <li>
              3) En los casos en los que una Actividad contratada sea una de
              riesgo, el Usuario/Consumidor asume el riesgo de participar en la
              Actividad.
            </li>
          </ul>

          <h3>V. ALQUILER DE AUTOS</h3>
          <ul class="clear">
            <li>
              1) El servicio de alquiler de auto se ofrecerá dentro del botón
              "Rappi Travel". El periodo de duración del servicio dependerá de
              las fechas seleccionadas por el Usuario/Consumidor en el proceso
              de compra.
            </li>
            <li>
              2) La tarifa de alquiler de auto incluye kilometraje ilimitado y
              seguros mínimos requeridos en el destino. Los servicios
              adicionales requeridos por el Usuario/Consumidor deberán ser
              agregados a la compra. Se entiende por servicios adicionales,
              entre otros, GPS, Wifi, seguros/coberturas adicionales, entre
              otros.
            </li>
            <li>
              3) La tarifa de alquiler de auto no incluye impuestos o tasas
              locales a menos que sea explícitamente informado por el Prestador,
              así como tampoco el pago de multas, infracciones, servicio de
              grúas, combustible, entrega de auto en otra ciudad, peajes ni
              cualquier otro servicio adicional, a menos que este haya sido
              contratado con el Prestador.
            </li>
            <li>
              4) Se aplicarán las condiciones y requisitos de edad, permisos y
              calificación crediticia vigentes y necesarias para la prestación
              del servicio de alquiler de auto. Cada Prestador especificará
              estas condiciones, las cuales deben ser consultadas por el
              Usuario/Consumidor.
            </li>
            <li>
              5) La reserva de un auto a través del botón "Rappi Travel" dentro
              de la plataforma Rappi, se realiza para una clase de auto, no para
              vehículos de marcas, años o modelos específicos.
            </li>
            <li>
              6) Las solicitudes de cambios o cancelaciones estarán sujetas a
              las políticas informadas por el Prestador. Estas solicitudes
              deberán ser notificadas a Travel Moustache con una anticipación no
              menos a veinticuatro (24) horas antes de la fecha de iniciación
              del alquiler.
            </li>
            <li>
              7) El Usuario/Consumidor deberá presentar una tarjeta de crédito a
              nombre del conductor. El Prestador podrá realizar un bloqueo
              correspondiente al monto de la garantía. Igualmente, éste podrá
              negar la prestación del servicio de alquiler de auto en caso de no
              presentarse la garantía mediante tarjeta de crédito.
            </li>
            <li>
              8) La intermediación prestada por parte de Travel Moustache en lo
              referente al alquiler o renta de automóviles en la República de
              Colombia, está regulada por un conjunto de normas, entre ellas, el
              Código Civil, el Código de Comercio, la Ley 1480 de 2011 (Estatuto
              del Consumidor), la Ley 300 de 1996 (Ley General del Turismo), y
              sus decretos reglamentarios, además de las disposiciones
              especiales establecidas por el Ministerio de Comercio, Industria y
              Turismo y las demás autoridades regulatorias, como la
              Superintendencia de Industria y Comercio Colombiana.
            </li>
          </ul>

          <h3>VI. TRANSPORTE TERRESTRE Y/O BUSES</h3>
          <p>
            ● Para efectos de esta sección Empresa de Autobuses será aquella que
            contrata el Usuario/Consumidor para la prestación del servicio de
            transporte terrestre o autobús.
          </p>
          <ul class="clear">
            <li>
              1) Una vez confirmada la solicitud de compra por medio de correo
              electrónico, el Usuario/Consumidor recibirá a su correo
              electrónico registrado en la plataforma Rappi, el voucher del
              Servicio Turístico, el cual deberá imprimir y llevar a la terminal
              de transporte. Al momento de viajar, el Pasajero debe recoger el
              boleto en el mostrador del Prestador, el cual para efectos de esta
              sección se denominará "Empresa Transportadora". Se aclara que este
              proceso deberá ser realizado por el Pasajero antes de abordar.
              Igualmente, se aclara que el Pasajero deberá presentarse en el
              mostrador, por regla general, con una antelación de mínimo una (1)
              hora sobre el horario de salida previsto, entendiéndose que en
              caso de no presentarse y/o no presentarse con el tiempo
              suficiente, el Usuario/Consumidor y el Pasajero no tendrán derecho
              a exigir el reembolso total o parcial del importe abonado. El
              Usuario/Consumidor y el Pasajero deberán consultar las exigencias
              de la Empresa de Autobuses contratada.
            </li>
            <li>
              2) Adicionalmente, el Pasajero deberá contar con la documentación
              de viaje requerida. En caso de que los datos registrados en el
              boleto no coincidan con la documentación de viaje que se presenta
              antes de subir al autobús, el Pasajero no podrá viajar. Las
              Empresas de Autobuses se reservan el derecho de brindar el
              Servicio Turístico adquirido mediante otra empresa cuando por
              razones técnicas u operativas, se vean imposibilitadas a hacerlo
              con sus unidades. Sin perjuicio de lo anterior, las Empresas de
              Autobuses deben respetar el precio, calidad y categoría de
              servicio adquirida por el Usuario/Consumidor, salvo que la
              modificación se presente con ocasión de un evento de fuerza mayor
              o caso fortuito.
            </li>
            <li>
              3) Los niños menores de 9 años no pueden viajar solos bajo ninguna
              circunstancias. Los niños de 9 años de edad pueden viajar
              únicamente acompañados de otra persona, quien por lo menos debe
              tener 16 años de edad. Los niños de 10 años en adelante pueden
              viajar sin acompañante. La Empresa Transportadora podrá solicitar
              el documento de identificación para comprobar la edad del menor.
              Todo niño menor de 18 años que viaje sin acompañante debe ser
              transportado con el permiso de viaje correspondiente, para lo cual
              deberá diligenciarse la autorización de viaje adjuntando copia del
              documento de identidad de quien autoriza y del menor. Se aclara
              que la autorización de viaje debe ser gestionada por el Pasajero
              directamente.
            </li>
            <li>
              4) Franquicia de Equipaje: Las Empresas Transportadoras tienen
              diferentes políticas de franquicia de equipaje. Estas podrán
              variar según la Empresa Transportadora y la clase en que se viaje,
              algunas tarifas no incluyen franquicia de equipaje. El
              Usuario/Consumidor deberá consultarlas antes de viajar.
            </li>
            <li>
              5) Travel Moustache no se hace responsable por pérdida o daños
              sufridos por objetos de valor extraordinario que el Pasajero lleve
              consigo. Las Empresas Transportadoras tampoco son responsables por
              la pérdida de equipaje de mano y de los demás efectos personales
              que hayan quedado bajo la custodia del Pasajero, salvo culpa de la
              Empresa Transportadora.
            </li>
            <li>
              6) Por disposiciones migratorias de cada país, en caso de que el
              Pasajero cuente con un pasaje únicamente de ida, y éste no sea
              residente del país de destino, podrá ser requerido por las
              autoridades migratorias a justificar las razones por las que no
              cuenta con un pasaje de regreso. El Usuario/Consumidor deberá
              consultar al Consulado o Embajada correspondiente antes de
              efectuar la reserva.
            </li>
          </ul>
        </ng-container>

        <app-terms-and-conditions-br *ngIf="isBR"></app-terms-and-conditions-br>
        <app-terms-and-conditions-mx *ngIf="isMX"></app-terms-and-conditions-mx>
        <app-terms-and-conditions-ar *ngIf="isAR"></app-terms-and-conditions-ar>
        <app-terms-and-conditions-pe *ngIf="isPE"></app-terms-and-conditions-pe>
        <app-terms-and-conditions-cl *ngIf="isCL"></app-terms-and-conditions-cl>
        <app-terms-and-conditions-uy *ngIf="isUY"></app-terms-and-conditions-uy>
      </div>
    </div>
  </div>
</ng-template>
